// extracted by mini-css-extract-plugin
export default {"trigger":"Popover__trigger___n9fs_","icon":"Popover__icon___e7ns_","content":"Popover__content___z8ZLu"};